<template>
  <div class="success-700 spacex-4 vertical-centering">
    <CheckIcon />
    <span>{{ success || $t('Changes have been successfully saved') }}</span>
  </div>
</template>

<script>
  import CheckIcon from '@/assets/icons/success.svg';

  export default {
    name: 'SuccessAlert',
    components: {
      CheckIcon,
    },
    props: {
      success: {
        type: String,
        default: '',
      },
    },
  };
</script>
